// extracted by mini-css-extract-plugin
export var card = "PickSlipCard-module--card--37c6b";
export var pick = "PickSlipCard-module--pick--b07df";